/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable arrow-body-style */
/* eslint-disable no-param-reassign */
import { Core, EventObject } from 'cytoscape';
import { useCyNodeHoverStore } from './cyNodeHoverStore';

enum OverlayState {
  showing = 'showing',
  shown = 'shown',
  hiding = 'hiding',
  hidden = 'hidden',
}

export const graphNodeHoverApi = nodeHoverApiFn();

function nodeHoverApiFn() {
  let overlayElement: HTMLDivElement | null = null;
  let hoverEvent: EventObject | null = null;
  let transitionTimeout: number = 0;
  let cy: Core;
  let container: HTMLDivElement;
  const store = useCyNodeHoverStore;

  return {
    mouseEnterOverlay,
    mouseLeaveOverlay,
    setOverlayElement,
    applyCy,
  };

  // #region Public functions
  function applyCy(cyInstance: Core, containerElement: HTMLDivElement) {
    cy = cyInstance;
    container = containerElement;

    document.removeEventListener('keydown', onOverlayExitKey);
    document.addEventListener('keydown', onOverlayExitKey);

    cy.off('mouseover', 'node', onNodeEnter);
    cy.off('mouseout', 'node', onNodeExit);
    cy.off('mousedown', 'node', clearOverlay);

    cy.on('mouseover', 'node', onNodeEnter);
    cy.on('mouseout', 'node', onNodeExit);
    cy.on('mousedown', 'node', clearOverlay);
  }

  function setOverlayElement(element: HTMLDivElement) {
    overlayElement = element;
  }
  function mouseEnterOverlay() {
    holdState();
  }
  function mouseLeaveOverlay(e: React.MouseEvent) {
    if (isMouseOverNode(hoverEvent!.target, e.clientX, e.clientY)) {
      holdState();
      return;
    }
    transitionState(OverlayState.hiding, OverlayState.hidden);
  }
  // #endregion Public functions

  // #region Private functions
  function holdState() {
    clearTimeout(transitionTimeout);
  }

  function clearOverlay() {
    transitionState(OverlayState.hidden, OverlayState.hidden);
  }

  async function transitionState(
    nowState: OverlayState,
    nextState: OverlayState
  ) {
    clearTimeout(transitionTimeout);
    transitionTimeout = window.setTimeout(() => changeState(nextState), 300);
    changeState(nowState);

    function changeState(state: OverlayState) {
      if (state === OverlayState.showing) {
        container.style.cursor = 'pointer';
        const { typeLabel, value } = hoverEvent!.target.data();
        store.setState({
          clazz: 'invisible',
          copied: false,
          nodeValue: value,
          nodeLabel: typeLabel,
        });
      }

      if (state === OverlayState.hiding) {
        container.style.cursor = 'default';
      }

      if (state === OverlayState.shown) {
        store.setState({
          style: { ...store.getState().style, pointerEvents: 'auto' },
        });

        const { left, top } = container.getBoundingClientRect();
        const domCoords = hoverEvent!.target.renderedPosition();

        const { x, y } = getVisibleOverlayXy(
          overlayElement!,
          left + domCoords.x,
          top + domCoords.y
        );

        store.setState({
          style: { ...store.getState().style, left: `${x}px`, top: `${y}px` },
          clazz: 'show',
        });
      }

      if (state === OverlayState.hidden) {
        container.style.cursor = 'default';
        store.setState({
          style: { ...store.getState().style, pointerEvents: 'none' },
          clazz: '',
        });
      }
    }
  }

  function onOverlayExitKey(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      transitionState(OverlayState.shown, OverlayState.hidden);
    }
  }

  function onNodeEnter(e: EventObject) {
    hoverEvent = e;
    transitionState(OverlayState.showing, OverlayState.shown);
  }

  function onNodeExit() {
    transitionState(OverlayState.hiding, OverlayState.hidden);
  }

  function isMouseOverNode(
    node: cytoscape.NodeSingular,
    mouseX: number,
    mouseY: number
  ): boolean {
    const containerRect = container.getBoundingClientRect();
    const x = mouseX - containerRect.left;
    const y = mouseY - containerRect.top;

    const pos = node.renderedPosition();
    const width = node.renderedWidth();
    const height = node.renderedHeight();

    return (
      x >= pos.x - width / 2 &&
      x <= pos.x + width / 2 &&
      y >= pos.y - height / 2 &&
      y <= pos.y + height / 2
    );
  }

  function getVisibleOverlayXy(overlay: HTMLDivElement, x: number, y: number) {
    const tooltipWidth = overlay.offsetWidth;
    const tooltipHeight = overlay.offsetHeight;
    const pageWidth = window.innerWidth;
    const pageHeight = window.innerHeight;

    let newX = x;
    let newY = y;

    if (x + tooltipWidth > pageWidth) {
      newX = x - tooltipWidth;
    }
    // Prevent overflow at the bottom
    if (y + tooltipHeight > pageHeight) {
      newY = y - tooltipHeight;
    }

    return { x: newX, y: newY };
  }
  // #endregion  Private functions
}
